module.exports = __webpack_public_path__ + "static/media/icra25allanwang.e911b014.jpeg";